// lib
import React from "react";
import { useTranslation } from "react-i18next";

export default () => {
  const { t } = useTranslation();
  return (
    <main>
      <p>{t("errors.notFound")}</p>
    </main>
  );
};
